import { cn } from '@/lib/utils';
import { AgentChatIndicator } from '@/components/agents-ui/agent-chat-indicator';

export interface ChatTypingDotsProps {
  className?: string;
  /** Visually-hidden label announced to assistive tech (defaults to "Anaka is thinking"). */
  label?: string;
}

/**
 * Inline "Anaka is working" cue shown inside an empty assistant bubble (and the
 * detailed-mode status line) while the model is thinking/streaming.
 *
 * Now renders LiveKit's Agents UI `AgentChatIndicator` (a single pulsing dot) in
 * place of the former three bouncing dots. The wrapper keeps the `chat-typing-dots`
 * test id and the visually-hidden label so call sites, screen-readers and existing
 * tests are unchanged.
 */
export function ChatTypingDots({
  className,
  label = 'Anaka is thinking',
}: ChatTypingDotsProps) {
  return (
    <span
      className={cn('inline-flex items-center', className)}
      data-testid="chat-typing-dots"
    >
      <span className="sr-only">{label}</span>
      <AgentChatIndicator size="sm" aria-hidden />
    </span>
  );
}
